<template>
	<div style="display:flex; justify-content: flex-end; gap: 20px">
		<Select
			:model-value="sort"
			:options="sortItems"
			:placeholder="placeholder"
			width="300"
			align="right"
			@change="onChangeSort"
		>
			<template v-slot:input="{ onOpen }">
				<div
					class="sort-select"
					@click="onOpen">
					{{ title }}
					<IconArrowDown/>
				</div>
			</template>
		</Select>

		<div class="sort-order icon-descending" :class="order === 10 ? 'sort-order_asc' : 'sort-order_desc'" @click="onClickOrder"></div>
	</div>
</template>

<script>
export default {
	name: 'SortOrderBy',
	props: {
		sort: {
			type: [Number, null],
			required: true
		},
		sortItems: {
			type: Array,
			required: true
		},
		order: {
			type: Number,
			required: true
		},
		placeholder: {
			type: String,
			default: 'sortBy'
		},
	},
	data() {
		return {
			sortLocal: this.sort
		}
	},
	computed: {
		title() {
			return this.sort ? this.$t(this.placeholder) + ': ' + this.sortItems.find(item => item.id === this.sort).name : '';
		}
	},
	methods: {
		onClickOrder() {
			this.$emit('update:order', this.order === 10 ? 20 : 10)
			this.$emit('change');
		},
		onChangeSort(value) {
			// console.log('onChangeSort', value)
			this.$emit('update:sort', value)
			this.$emit('change');
		}
	}
}
</script>

<style scoped lang="scss">
.sort-select {
	display: flex;
	align-items: center;
	gap: 5px;
	font-size: 17px;
}
.sort-order {
	font-size: 26px;
	cursor: pointer;

	&_asc {
		transform: scaleY(1);
		translate: 0 3px;
	}

	&_desc {
		transform: scaleY(-1);
		translate: 0 -6px;
	}
}
</style>
